import { PersonalConnection } from '@/services/personal-connections/types';

/**
 * Whether a consent in flight has finished: the provider reports a live
 * grant and no further consent is pending beside it (a reconnect leaves the
 * old grant live until the new one lands).
 */
export const isConsentSettled = (row: PersonalConnection | undefined) =>
  Boolean(row && row.status === 'connected' && !row.pending_authorization);
